// @flow
import * as React from 'react';
import { InfoBox } from '@phg/stilo-toolbox/v2/component';
import { entityTermsAndConditions, networkTermsAndConditions, termsAndConditions } from '../field/name';
import {
    TermsAndConditionsField,
    FocusOfContentSelectField,
    PromotionalMethodSelectField,
    WebsiteField,
    CompanyNameField,
    createFieldError,
    Hcaptcha,
    Recaptcha } from '../field';

import Buttons from '../button';

type CompanyComponentProps = {
    networkId: string,
    captchaProvider?: string
};

const TermsAndConditionsError = createFieldError([entityTermsAndConditions, networkTermsAndConditions, termsAndConditions]);

const CompanyComponent = ({ networkId, captchaProvider }: CompanyComponentProps) => (
    <form>
        <FocusOfContentSelectField />
        <PromotionalMethodSelectField />
        <WebsiteField />
        <CompanyNameField />

        <InfoBox>
            <TermsAndConditionsField networkId={networkId} />
        </InfoBox>
        <TermsAndConditionsError />

        <Buttons back submit />
        {captchaProvider !== ''
            ? captchaProvider !== 'recaptcha'
                ? (
                    <Hcaptcha />
                ) : (
                    <Recaptcha />
                ) 
            : null}
    </form>
);

export default CompanyComponent;
